import React, { useRef, useEffect } from 'react';

import useIntersection from 'buena-suerte/lib/hooks/useIntersection';
import classNames from 'classnames';

export default ({ autoplay, type, videoId }) => {
  const intersectionRef = useRef();
  const isIntersected = useIntersection(intersectionRef);

  useEffect(() => {
    const Plyr = require('plyr');
    const player = new Plyr('#player', {
      autoplay: false,
      muted: false,
      hideControls: false,
      clickToPlay: true,
      loop: {
        active: false,
      },
      playsinline: true,
    });
  }, [type]);

  return (
    <section
      ref={intersectionRef}
      className={classNames(
        'spotlight__inline-img x db p2 pt5--lg pb5--lg reveal',
        { revealed: isIntersected }
      )}
    >
      {type === 'youtube' ? (
        <div className="plyr__video-embed" id="player">
          <iframe
            src={`https://www.youtube.com/embed/${videoId}?origin=https://eugeniedetroit.com&amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1`}
            allowFullScreen
            allowtransparency="true"
            allow="autoplay"
          ></iframe>
        </div>
      ) : (
        <div className="plyr__video-embed" id="player">
          <iframe
            src={`https://player.vimeo.com/video/${videoId}?loop=false&amp;byline=false&amp;portrait=false&amp;title=false&amp;speed=true&amp;transparent=0&amp;gesture=media`}
            allowFullScreen
            allowtransparency="true"
            allow="autoplay"
          ></iframe>
        </div>
      )}
    </section>
  );
};
